// extracted by mini-css-extract-plugin
module.exports = {"page":"page__qz5RS"};